export default "__VITE_ASSET__C9KSc2Ry__"